import React from "react";
import "./WalletCard.css";

const WalletCard = ({ wallet }) => {
  return (
    <div className="wallet-card">

      <div className="wallet-header">

        <div>
          <h3>💰 Wallet</h3>
          <p>Your business earnings overview</p>
        </div>

        <span className="wallet-badge">
          Active
        </span>

      </div>

      <div className="wallet-body">

        <div className="wallet-item">

          <div>
            <span>Total Earnings</span>
            <small>Lifetime earnings</small>
          </div>

          <strong className="earning">
            ₹ {wallet?.totalEarnings || 0}
          </strong>

        </div>

        <div className="wallet-item">

          <div>
            <span>Available Balance</span>
            <small>Ready for withdrawal</small>
          </div>

          <strong className="available">
            ₹ {wallet?.availableBalance || 0}
          </strong>

        </div>

        <div className="wallet-item">

          <div>
            <span>Withdrawn</span>
            <small>Total transferred</small>
          </div>

          <strong className="withdrawn">
            ₹ {wallet?.withdrawn || 0}
          </strong>

        </div>

      </div>

      <div className="wallet-footer">
        💡 Withdrawals are credited to your registered bank account.
      </div>

    </div>
  );
};

export default WalletCard;